import { BufferAttribute, BufferGeometry, Line, LineBasicMaterial } from "three";
export class CustomLine extends Line {
    constructor(name, color, positions = []) {
        super(new BufferGeometry(), new LineBasicMaterial({ color: color }));
        this.name = name;
        this.interceptedByRaycaster = false;
        this.setGeoPoints(positions);
    }
    updateGeoPoints(positions, ...indexes) {
        if (!this.createAttributes(positions)) {
            const array = this.geometry.getAttribute("position").array;
            for (const index of indexes) {
                const arrayIndex = index * 3;
                array[arrayIndex] = positions[index].x;
                array[arrayIndex + 1] = positions[index].y;
                array[arrayIndex + 2] = positions[index].z;
            }
            this.update();
        }
    }
    setGeoPoints(positions) {
        if (!this.createAttributes(positions)) {
            this.fillPositionsArray(positions, this.geometry.getAttribute("position").array);
            this.update();
        }
    }
    createAttributes(positions) {
        if (!(this.geometry.getAttribute("position")?.count === positions.length)) {
            const array = this.fillPositionsArray(positions);
            this.geometry.setAttribute('position', new BufferAttribute(array, 3));
            this.update();
            return true;
        }
        return false;
    }
    fillPositionsArray(positions, target) {
        target ?? (target = new Float32Array(positions.length * 3));
        for (let i = 0; i < positions.length; i++) {
            const index = i * 3;
            target[index] = positions[i].x;
            target[index + 1] = positions[i].y;
            target[index + 2] = positions[i].z ?? 0;
        }
        return target;
    }
    update() {
        this.geometry.getAttribute("position").needsUpdate = true;
        this.geometry.computeBoundingSphere();
        this.needsRender = true;
    }
}
//# sourceMappingURL=CustomLine.js.map